__turbopack_context__.v({
  "className": "playfair_display_af63dd2b-module__QcoXmq__className",
});
